import React, { useState, useEffect} from 'react';
import { NavLink  } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';
import { FaArrowCircleLeft } from 'react-icons/fa';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';

export default function Prestamos(){
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [carpetasprestadas, setCarpetasprestadas] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const columnscarpetas = [
        {
            name: 'Devolver',
            cell: row => (
            <div>
                <button type="button" onClick={() => DevolverCarpeta(row)} 
                        style={{backgroundColor: 'blue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Devolver">
                    <FaArrowCircleLeft size={20} color="white" />
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'id', selector: row => row.id, sortable: true, width:'5%' },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'10%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '15%'},
        { name: 'Fecha', selector: row => row.reg_fechapres.split('T')[0], sortable: true, width: '10%' },
        { name: 'Hora', selector: row => row.reg_horapres, sortable: true, width: '10%' },
        { name: 'Prestada a', selector: row => row.usr_nombre, sortable: true, width: '15%' },
        { name: 'Observaciones', selector: row => row.reg_observaciones, sortable: true, width: '25%' }
    ];
    useEffect(() => {
        const fetchData = async () => {
            await ConsultarCarpetas();
        };
        fetchData();
    }, []);
    async function ConsultarCarpetas(){
        const url = '/archivo/consultarcarpetasprestadas';
        const obj = {usrRolid: rol }
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setCarpetasprestadas(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    async function  DevolverCarpeta (row){
        setCargando(true);
        const url = '/archivo/devolvercarpeta';
        const obj = {idPrestamoCarpeta: row.id }
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                Mensaje('Devolver carpeta', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Devolver carpeta', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Devolver carpeta', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            await ConsultarCarpetas();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Prestamos" idCabezaFamilia={"1"} url={'/archivo/0'} nombreurl="Archivo" nombreform="Prestamos" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="card-body table-responsive p-0">
                        <DataTable
                            title="Carpetas prestadas"
                            columns={columnscarpetas}
                            data={carpetasprestadas}    
                            progressPending={Cargando}
                            pagination
                            noDataComponent="No hay datos para mostrar"
                        /> 
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
            
        </div>
    );
}